import plus from "../assets/icons/plus-aquare.svg";
import minus from "../assets/icons/minus-aquare.svg";
import TableStyle from "../templates/Table.style";
var tableData = {
  name: 'table',
  data: [{
    fontFamily: 'PingFangSC-Medium',
    bordered: false,
    striped: true,
    stripedBg: "#FBFDFF",
    // rgb(251,253,255) 4.1.x 和 5.1.x 统一样式，渐变会使得禁用样式有问题
    borderColor: '#f1f1f1',
    headHeight: 36,
    headBg: '#fafafa',
    headFontColor: '#aaadba',
    headFontSize: 12,
    // 调整默认行高
    rowHeight: 29,
    bodyBg: '#fff',
    bodyHoverBg: '#eff6ff',
    bodyFontSize: 12,
    bodyFontColor: '#5a6677',
    expandIcon: plus,
    expandedIcon: minus,
    expandIconColor: 'rgba(0, 0, 0, .6)',
    filterBackgroundColor: '#4f7de7',
    dybarNotFuzzyRefreshIconMarginTop: '8',
    dybarNotFuzzyFilterButtonsMarginTop: '3'
  }],
  extraTemplate: {
    pro: TableStyle
  }
};
export default tableData;